import { CloseSVG } from '@sbercloud/uikit-product-icons';
import { ButtonFunction } from '@snack-uikit/button';
import { Typography } from '@snack-uikit/typography';
import { Dispatch, SetStateAction } from 'react';

import s from './styles.module.scss';

export function ThanksBlock({ handleChangeOpenState }: { handleChangeOpenState: Dispatch<SetStateAction<boolean>> }) {
  const handleCloseBlock = () => handleChangeOpenState(false);

  return (
    <div className={s.thanks_block_wrapper}>
      <Typography.SansTitleM className={s.thanks_block_text}> Спасибо за отзыв и комментарий! </Typography.SansTitleM>
      <ButtonFunction icon={<CloseSVG />} onClick={handleCloseBlock} />
    </div>
  );
}
